module.exports = __webpack_public_path__ + "static/img/service.416a44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/service.png
// module id = hSdo
// module chunks = 1